import { render, staticRenderFns } from "./ReCaptchaPolicy.vue?vue&type=template&id=710bda2a&scoped=true&"
import script from "./ReCaptchaPolicy.vue?vue&type=script&lang=js&"
export * from "./ReCaptchaPolicy.vue?vue&type=script&lang=js&"
import style0 from "./ReCaptchaPolicy.vue?vue&type=style&index=0&id=710bda2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710bda2a",
  null
  
)

export default component.exports